











































import { FormItem, Select, Option } from 'element-ui'
import { Vue, Prop, Component } from 'vue-property-decorator'

import CreditCard from '@/models/credit-card'

@Component({
  components: {
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
  },
})
export default class CreditCardDropdown extends Vue {
  @Prop() creditCards!: CreditCard[]
  @Prop() cardId!: number

  onChoosePaymentMethod(value: Event) {
    this.$emit('on-update-enroll-tab-info', {
      name: 'creditCardId',
      value,
    })
  }

  onResetPaymentMethod() {
    this.$emit('on-update-enroll-tab-info', {
      name: 'creditCardId',
      value: null,
    })
  }
}
